import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
export const HorizontalRuleIcon = ({ color, ...props }) => {
    const theme = useTheme();
    return (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("rect", { x: "2.5", y: "9.375", width: "15", height: "1.25", fill: color ?? theme.colors.grey90 }) }));
};
//# sourceMappingURL=horizontal_rule_icon.js.map